// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export class NodeSearchRequest {
	public UserId: number = 0;
	public Subdomain: string = "";
}